import React from "react";

const StopCampaignConfirmation = () => {
  return (
    <div className="p-5 flex-col-centered items-start gap-2">
      <span className="text-lg font-[600] text-grey-700">Turn off campaign?</span>
      <span className="text-sm font-[400] text-grey-600">
        Turning off this campaign will stop sending the campaign messages for this lead.
      </span>
    </div>
  );
};

export default StopCampaignConfirmation;
